import { TextField, Select } from '@occc-app/design-system';
import { User_Role } from '@occc/graphql';

const getInputProps = (inputName: string) => ({
  'data-testid': `user-form-field-${inputName}`,
});

const firstNameInputProps = getInputProps('firstName');
const lastNameInputProps = getInputProps('lastName');
const emailInputProps = getInputProps('email');
const roleInputProps = getInputProps('role');

const selectData = [
  { label: 'Admin', value: User_Role.Admin },
  { label: 'Support', value: User_Role.Support },
  { label: 'Site Tech', value: User_Role.Sitetech },
  { label: 'Admin Read Only', value: User_Role.AdminReadOnly },
  { label: 'Retailer Connect User', value: User_Role.RcUser },
];

export const FormContent = () => {
  return (
    <>
      <TextField
        name='firstName'
        label='First Name'
        inputProps={firstNameInputProps}
        margin='normal'
        sx={{ mt: 0 }}
      />
      <TextField
        name='lastName'
        label='Last Name'
        inputProps={lastNameInputProps}
        margin='normal'
      />
      <TextField
        name='email'
        label='Email'
        multiline
        type='email'
        inputProps={emailInputProps}
        margin='normal'
      />
      <Select
        name='userRole'
        label='Role'
        data={selectData}
        inputProps={roleInputProps}
        formControlProps={{ size: 'medium', margin: 'normal', sx: { mb: 0 } }}
      />
    </>
  );
};
